<template>
  <div class="main-info">
    <el-row>
      <el-col>
        <h4>Datos Generales del Cliente</h4>
        <hr>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <h5>
          Nombre del Cliente
        </h5>
        <p>{{ customer.firstName }}</p>
      </el-col>
      <el-col :span="8">
        <h5>
          Apellidos del Cliente
        </h5>
        <p>{{ customer.lastName }}</p>
      </el-col>
      <el-col :span="8">
        <h5>
          Compañia
        </h5>
        <p>{{ customer.company }}</p>
      </el-col>
      <el-col :span="8">
        <h5>
          Distribuidor
        </h5>
        <p>{{ customer.dealer ? customer.dealer.name : '' }}</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h4>Datos de Contacto</h4>
        <hr>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <h5>Calle</h5>
        <p>{{ customer.street }}</p>
      </el-col>
      <el-col :span="8">
        <h5>Número Exterior</h5>
        <p>{{ customer.outdoor }}</p>
      </el-col>
      <el-col :span="8">
        <h5>Número Interior</h5>
        <p>{{ customer.indoor }}</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <h5>Barrio</h5>
        <p>{{ customer.neighborhood }}</p>
      </el-col>
      <el-col :span="8">
        <h5>Estado</h5>
        <p>{{ customer.state }}</p>
      </el-col>
      <el-col :span="8">
        <h5>Municipio</h5>
        <p>{{ customer.municipality }}</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <h5>Correo Electrónico</h5>
        <p>{{ customer.email }}</p>
      </el-col>
      <el-col :span="8">
        <h5>Teléfono</h5>
        <p>{{ customer.phone }}</p>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <h5>Actividades del cliente:</h5>
        <div class="activities">
          <el-tag
            v-for="(activity, index) of customerActivities"
            :key="index">
            <span>{{ activity.activities.name }}</span>
            <span>{{ activity.surface > 0 ? parseFloat(activity.surface).toFixed(1) : 0 }} Ha.</span>
          </el-tag>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CustomersGuards from '@/guards/customers.guards'
export default {
  name: 'CustomersInfo',
  computed: {
    customer () {
      return this.$store.getters['customers/item']
    },
    customerActivities () {
      return this.$store.getters['customerActivities/items']
    }
  },
  beforeRouteUpdate: CustomersGuards.onGetCustomer
}

</script>

<style scoped lang="scss">
  .main-info{
    padding: 30px;
    background-color: #ffffff;
    min-height: 50vh;
    .activities{
      display: inline-block;
      .el-tag{
        margin-right: 10px;
      }
    }
    hr{
      height: 1px;
      background-color: #dddddd;
      border: none;
    }
    h4{
      @include font-lato(14px, bold);
      margin: 10px 0;
    }
    h5{
      color: #3E3E3E;
      @include font-lato(13px, bold);
    }
    p{
      color:#B5AFAF;
        @include font-primary(14px, regular);
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/customers/customers-info.vue